// extracted by mini-css-extract-plugin
module.exports = {"subTitle":"SecurePhoneAuthentication_subTitle__2DUuJ","subTitlePhone":"SecurePhoneAuthentication_subTitlePhone__1wvwD"};